import React from 'react';

import viewNameStore, { ViewNameEnum } from 'ts/store/ViewName';
import themeSettings from 'ts/store/ThemeSettings';

import style from '../../styles/logo.module.scss';

interface ILogoProps {
  center?: boolean;
}

function Logo({ center }: ILogoProps) {
  const { logo, title } = themeSettings.getLogo() || {};
  const isDefault = logo === './assets/logo.svg';

  return (
    <figure
      className={center ? `${style.logo} ${style.logo_center}` : style.logo}
    >
      <a
        href="/"
        className={style.logo_link}
        onClick={(e) => {
          e.preventDefault();
          window.history.pushState(null, '', '/');
          viewNameStore.toggle(ViewNameEnum.WELCOME);
        }}
      >
        <img
          src={logo || ''}
          title={title || ''}
          className={
            isDefault
              ? `${style.logo_icon} ${style.logo_default}`
              : style.logo_icon
          }
        />
      </a>
    </figure>
  );
}

Logo.defaultProps = {
  center: false,
};

export default Logo;
